<template>
  <div>
    <autocomplete
      ref="autocomplete"
      :source="suggestions"
      :disableInput="disabled"
      resultsValue="name"
      @selected="handleSelected"
      inputClass="invites-autocomplete"
      placeholder="Enter invitee name"
    >
    </autocomplete>
  </div>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete';

export default {
  components: { Autocomplete },

  props: {
    suggestions: Array,
    disabled: Boolean,
  },

  methods: {
    handleSelected(user) {
      this.$emit('selected', user.selectedObject);
      this.$refs.autocomplete.clear();
    },
  },
};
</script>

<style lang="scss">
  .invites-autocomplete {
    background: none;
    border: none;
    outline: none;
    width: 100%;
  }

  .autocomplete__box {
    border: none !important;
    border-bottom: 1px solid #D8D8D8 !important;
  }

  .autocomplete__results {
    left: -30px;
    top: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Booking/Invites/Autocomplete.vue